import React from 'react';
import { useTranslation } from 'react-i18next';
import type { DayForecast } from '../../types';

const WEEKDAYS_NO = ['Søn', 'Man', 'Tir', 'Ons', 'Tor', 'Fre', 'Lør'];
const WEEKDAYS_EN = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

const WeatherBar: React.FC<{ forecasts: DayForecast[] }> = ({ forecasts }) => {
  const { t, i18n } = useTranslation();
  const weekdays = i18n.language === 'no' ? WEEKDAYS_NO : WEEKDAYS_EN;

  if (forecasts.length === 0) return null;

  return (
    <div className="mb-4">
      <p className="text-3xs font-black text-[var(--text-muted)] uppercase tracking-widest mb-2 px-1">
        {t('discover.weather_title')}
      </p>
      <div className="flex gap-2 overflow-x-auto pb-1 scrollbar-hide">
        {forecasts.map((day, i) => {
          const d = new Date(day.date + 'T12:00:00');
          const isToday = i === 0;
          const dayLabel = isToday ? t('discover.today') : weekdays[d.getDay()];
          const iconUrl = `https://raw.githubusercontent.com/metno/weathericons/main/weather/svg/${day.symbolCode}.svg`;

          return (
            <div
              key={day.date}
              className={`flex-shrink-0 flex flex-col items-center gap-0.5 px-3 py-2 rounded-xl ${
                isToday
                  ? 'bg-amber-500/15 ring-1 ring-amber-500/30'
                  : 'bg-[var(--bg-surface-alt)]'
              }`}
              style={{ minWidth: 64 }}
            >
              <span className={`text-2xs font-bold ${isToday ? 'text-amber-400' : 'text-[var(--text-muted)]'}`}>
                {dayLabel}
              </span>
              <img src={iconUrl} alt={day.symbolCode} className="w-7 h-7" loading="lazy" />
              <div className="flex items-baseline gap-1">
                <span className="text-xs font-bold text-[var(--text-primary)]">{day.tempMax}°</span>
                <span className="text-2xs text-[var(--text-muted)]">{day.tempMin}°</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default WeatherBar;
